import $ from "jquery";
import Request from "./request";

export default function($app) {
	const imagesContainer = $('.instagramTab .images');

	if(!(Request.getParameter('instagram') || $app.event().id() === 1547)) {
		return;
	}

	$('body').addClass('bottomInstagram');

	const __construct = function() {
		//todo: Получать тэг из Event
		const tag = 'top50sobakaru';
		$.getJSON('/player/instagram.php?tag='+tag, function(data) {
			for (let i=0; i<data.length; i++) {
				addImage(data[i]);
			}
		});

		$app.require('comet').on('instagram.media', function(images) {
			for (let i=0; i<images.length; i++) {
				addImage(images[i])
			}
		})
	};

	const addImage = function(image) {
		$('<img>')
			.addClass('instagramImage')
			.attr('src', image.image)
			.prependTo(imagesContainer)
			.wrap(function() {
				return '<a href="' + image.link + '" target="_blank" />'
			});
	};

	$app.on('start', function() {
		__construct();
	});
};
